<template>
  <v-container id="calculator-wrapper">
    <div class="hero-image hero-image1">
      <div class="hero-text">
        <h1 class="mb-4 heading">
            Calculate Monthly Earnings
          </h1>
          <h4 class="subheading">
            Practice Owner Calculator
          </h4>
          <h4 class="subheading">
            Single Hygiene
          </h4>
           <div class="state-select-wrapper">
              <v-select
                id="state-dropdown"
                :items="states"
                item-text="name"
                filled
                label="Choose A State"
                solo
                v-on:change="updateState"
                dense
                background-color="#FFFFFF"
                outlined
              >
              </v-select>
            </div>
      </div>
    </div>
    <v-container class="calculator-container">
      <v-row>
        <v-col class="input-column">
          <v-container>
            <v-row>
              <v-col class="section-header text-center header-text">INPUTS</v-col>
            </v-row>
            <v-row class="column-labels">
              <v-col></v-col>
              <v-col md="2" class="col-input">Scenario 1</v-col>
              <v-col md="2" class="col-input">Scenario 2</v-col>
            </v-row>
          </v-container>
          <v-row align="center" justify="center" class="calculator-row"><!--Production Per Day-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Production Per Day</span>
                </template>
                <span  v-html="this.tipProductionPerDay"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtProductionPerDayCurrent"
                  placeholder=""
                  type="text"
                  @input="updateFields"
                  filled
                  rounded
                  style="height: 30px; border-radius:10px;"
                  reverse
                  class="text-blue number-input"
                  hide-spin-buttons
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtProductionPerDayCalculated"
                  placeholder=""
                  type="text"
                  @input="updateFields"
                  filled
                  rounded
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!--Hourly Rate-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hourly Rate</span>
                </template>
                <span v-html="this.tipHourlyRate"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtHourlyRateCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtHourlyRateCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Hours Worked Per Day-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hours Worked Per Day</span>
                </template>
                <span v-html="this.tipHoursWorkedPerDay"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtHoursWorkedPerDayCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtHoursWorkedPerDayCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Days Worked Per Week -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Days Worked Per Week</span>
                </template>
                <span v-html="this.tipDaysWorkedPerWeek"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtDaysWorkedPerWeekCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtDaysWorkedPerWeekCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>

          <v-row align="center" justify="center" class="calculator-row"><!-- New Patient Net Promoter Score (NPS) -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >  New Patient Net Promoter Score (NPS) </span>
                </template>
                <span v-html="this.tipPatientLoyaltyScore"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtPatientLoyaltyScoreCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtPatientLoyaltyScoreCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>

          <v-row align="center" justify="center" class="calculator-row"><!-- MCD Profit Share Percent -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >  MCD Profit Share Percent </span>
                </template>
                <span v-html="this.tipMCDProfitSharePercent"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="txtMCDProfitSharePercentCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input percent-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="txtMCDProfitSharePercentCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input percent-input"
                ></v-text-field>
            </v-col>
          </v-row>

        </v-col>
        <v-col  class="blueBackground results-column">
          <v-container>
            <v-row>
              <v-col class="section-header text-center header-text">MONTHLY HYGIENIST PERFORMANCE</v-col>
            </v-row>
            <v-row class="column-labels">
              <v-col></v-col>
              <v-col md="2" class="col-input">Scenario 1</v-col>
              <v-col md="2" class="col-input">Scenario 2</v-col>
            </v-row>
          </v-container>
          <v-row align="center" justify="center" class="calculator-row"> <!--Hygiene Revenue -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hygiene Revenue</span>
                </template>
                <span v-html="this.tipHygieneRevenue"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultHygieneRevenueCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultHygieneRevenueCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!-- Hygiene Supplies -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hygiene Supplies</span>
                </template>
                <span v-html="this.tipHygieneSupplies"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultHygieneSuppliesCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultHygieneSuppliesCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="blueBackgroundHighlight"><!-- Gross Profit -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  > Gross Profit</span>
                </template>
                <span v-html="this.tipGrossProfit"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultGrossProfitCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultGrossProfitCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row results-section-header"><!-- Profit Sharing -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Profit Sharing</span>
                </template>
                <span v-html="this.tipProfitSharing"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="resultProfitSharingCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input percent-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="resultProfitSharingCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input percent-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row blueBackgroundHighlight"><!-- Total Eligible Profit Sharing -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  > Total Eligible Profit Sharing</span>
                </template>
                <span v-html="this.tipEligibleProfitSharing"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultEligibleProfitSharingCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultEligibleProfitSharingCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Hygienist Monthly Wages Paid -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hygienist Monthly Wages Paid</span>
                </template>
                <span v-html="this.tipLeadWages"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadWagesCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadWagesCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row darkBlueBackground"> <!-- Hygienist Earned Incentive -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  > Hygienist Earned Incentive</span>
                </template>
                <span v-html="this.tipLeadWages"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadEarnedIncentiveCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadEarnedIncentiveCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row darkBlueBackground"> <!-- Effective Hourly Rate -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  >Effective Hourly Rate</span>
                </template>
                <span v-html="this.tipLeadHourlyRateWithIncentive"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadHourlyRateWithIncentiveCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadHourlyRateWithIncentiveCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="last-line darkBlueBackground"> <!-- Total Hygienist Earnings -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  >Total Hygienist Earnings</span>
                </template>
                <span v-html="this.tipTotalHygienestEarnings"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultTotalHygienistEarningsCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultTotalHygienistEarningsCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>

          <v-container>
            <v-row>
              <v-col class="section-header text-center header-text mt-6">MONTHLY POP P&L</v-col>
            </v-row>
          </v-container>
          <v-row align="center" justify="center" class="last-line"> <!-- Employee Benefits -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >Employee Benefits</span>
                </template>
                <span v-html="this.tipEmployeeBenefits"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultEmployeeBenefitsCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultEmployeeBenefitsCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="last-line"> <!-- Center Gross Profit -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >Center Gross Profit</span>
                </template>
                <span v-html="this.tipCenterGrossProfit"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultCenterGrossProfitCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultCenterGrossProfitCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="last-line"> <!-- MCD Profit Sharing -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >MCD Profit Sharing</span>
                </template>
                <span v-html="this.tipMCDProfitSharing"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultMCDProfitSharingCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultMCDProfitSharingCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="last-line darkBlueBackground"> <!-- PC Net Profits -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  >PC Net Profits</span>
                </template>
                <span v-html="this.tipPCNetProfit"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultPCNetProfitsCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultPCNetProfitsCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>


          <v-row class="instructions-row">
            <v-col class= "instructions-right disclaimer">Hygiene supply costs may vary month to month. Example above reflective of supplies equal to 6.6% of hygiene revenue.</v-col>
          </v-row>
          <v-row class="instructions-row">
            <v-col class= "instructions-right disclaimer"><a target="_blank" v-bind:href="compensationProgramSummaryURL">{{compensationProgramSummaryText}}</a></v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<style scoped>
.number-input >>> input[type="number"] {
  -moz-appearance: textfield;
}
.number-input >>> input::-webkit-outer-spin-button,
.number-input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
<script>
  import html2canvas from 'html2canvas';
  export default {
    name: 'Calculator',
    methods: {
      updateFields (){
        this.numProductionPerDayCurrent = this.txtProductionPerDayCurrent.toString().replaceAll(',', '');
        this.numProductionPerDayCalculated = this.txtProductionPerDayCalculated.toString().replaceAll(',', '');

        /*Calculate results*/

        /*Hygiene Revenue*/
        this.resultHygieneRevenueCurrent = (this.numProductionPerDayCurrent * this.txtDaysWorkedPerWeekCurrent *4.4);
        this.resultHygieneRevenueCalculated = (this.numProductionPerDayCalculated * this.txtDaysWorkedPerWeekCalculated *4.4);
        /*Hygiene Supplies*/
        this.resultHygieneSuppliesCurrent = this.resultHygieneRevenueCurrent * .066;
        this.resultHygieneSuppliesCalculated = this.resultHygieneRevenueCalculated * .066;
        /*Gross Profit*/
        this.resultGrossProfitCurrent = this.resultHygieneRevenueCurrent - this.resultHygieneSuppliesCurrent - this.resultAssociateWagesCurrent;
        this.resultGrossProfitCalculated = this.resultHygieneRevenueCalculated - this.resultHygieneSuppliesCalculated - this.resultAssociateWagesCalculated;
        /*Profit Sharing*/
        this.resultProfitSharingCurrent = this.getProfitSharing (this.txtPatientLoyaltyScoreCurrent);
        this.resultProfitSharingCalculated = this.getProfitSharing (this.txtPatientLoyaltyScoreCalculated);
        /*Eligible Lead Profit Sharing*/
        this.resultEligibleProfitSharingCurrent = this.resultGrossProfitCurrent * this.resultProfitSharingCurrent/100;
        this.resultEligibleProfitSharingCalculated = this.resultGrossProfitCalculated * this.resultProfitSharingCalculated/100;
        /*Lead Wages*/
        this.resultLeadWagesCurrent = this.txtHourlyRateCurrent * this.txtHoursWorkedPerDayCurrent * this.txtDaysWorkedPerWeekCurrent * 4.4;
        this.resultLeadWagesCalculated = this.txtHourlyRateCalculated * this.txtHoursWorkedPerDayCalculated * this.txtDaysWorkedPerWeekCalculated * 4.4;
        /*Hygienist Monthly Wage*/
        this.resultHygienistWageAmountCurrent = parseFloat(this.txtHourlyRateCurrent) * this.txtHoursWorkedPerDayCurrent * this.txtDaysWorkedPerWeekCurrent * 4.4;
        this.resultHygienistWageAmountCalculated = parseFloat(this.txtHourlyRateCalculated) * this.txtHoursWorkedPerDayCalculated * this.txtDaysWorkedPerWeekCalculated * 4.4;
        /*Lead Earned Incentive*/
        if(this.resultHygienistWageAmountCurrent > this.resultEligibleProfitSharingCurrent){ this.resultLeadEarnedIncentiveCurrent = 0;}
        else{this.resultLeadEarnedIncentiveCurrent = this.resultEligibleProfitSharingCurrent - this.resultHygienistWageAmountCurrent}
        if(this.resultHygienistWageAmountCalculated > this.resultEligibleProfitSharingCalculated){ this.resultLeadEarnedIncentiveCalculated = 0;}
        else{this.resultLeadEarnedIncentiveCalculated = this.resultEligibleProfitSharingCalculated - this.resultHygienistWageAmountCalculated}
        /*this.resultTotalHygienistEarnings = this.resultHygienistWageAmount + this.resultLeadEarnedIncentive;*/
        /*Lead Effective Hourly Rate*/
        this.resultLeadEarnedIncentiveleadHourlyRateWithIncentiveCurrent = Number(this.txtHourlyRateCurrent) + (this.resultLeadEarnedIncentiveCurrent/(this.txtHoursWorkedPerDayCurrent*this.txtDaysWorkedPerWeekAssociateCurrent * 4.4));
        this.resultLeadEarnedIncentiveleadHourlyRateWithIncentiveCalculated = Number(this.txtHourlyRateCurrent) + (this.resultLeadEarnedIncentiveCalculated/(this.txtHoursWorkedPerDayCalculated*this.txtDaysWorkedPerWeekAssociateCalculated * 4.4));
        /*Hourly Incentive*/
        this.resultLeadHourlyRateWithIncentiveCurrent = Number(this.txtHourlyRateCurrent) + Number(this.resultLeadEarnedIncentiveCurrent/(this.txtHoursWorkedPerDayCurrent*this.txtDaysWorkedPerWeekCurrent*4.4));
        this.resultLeadHourlyRateWithIncentiveCalculated = Number(this.txtHourlyRateCalculated) + Number(this.resultLeadEarnedIncentiveCalculated/(this.txtHoursWorkedPerDayCalculated*this.txtDaysWorkedPerWeekCalculated*4.4));
        /*Hourly Rate With Incentive*/
        this.resultHourlyRateWithIncentiveCurrent = parseFloat(this.txtHourlyRateCurrent) + this.resultHourlyIncentiveCurrent;
        this.resultHourlyRateWithIncentiveCalculated = parseFloat(this.txtHourlyRateCalculated) + this.resultHourlyIncentiveCalculated;
        /*Total Hygienist Earnings*/
        this.resultTotalHygienistEarningsCurrent = (this.resultHygienistWageAmountCurrent + this.resultLeadEarnedIncentiveCurrent);
        this.resultTotalHygienistEarningsCalculated = (this.resultHygienistWageAmountCalculated + this.resultLeadEarnedIncentiveCalculated);
        /*Associate Revenue*/
        this.resultAssociateRevenueCurrent = this.txtProductionPerDayAssociateCurrent * this.txtDaysWorkedPerWeekAssociateCurrent * 4.4;
        this.resultAssociateRevenueCalculated = this.txtProductionPerDayAssociateCalculated * this.txtDaysWorkedPerWeekAssociateCalculated* 4.4;
        /*Associate Profit Sharing*/
        this.resultAssociateProfitSharingCurrent = 3;
        this.resultAssociateProfitSharingCalculated = 3;
        /*Associate Earned Incentive*/
        this.resultAssociateEarnedIncentiveCurrent = this.resultAssociateRevenueCurrent * this.resultAssociateProfitSharingCurrent/100;
        this.resultAssociateEarnedIncentiveCalculated = this.resultAssociateRevenueCalculated * this.resultAssociateProfitSharingCalculated/100;
        /*Associate Effective Hourly Rate*/
        this.resultAssociateHourlyRateWithIncentiveCurrent = Number(this.txtHourlyRateAssociateCurrent) + (this.resultAssociateEarnedIncentiveCurrent/(this.txtHoursWorkedPerDayAssociateCurrent*this.txtDaysWorkedPerWeekAssociateCurrent*4.4));
        this.resultAssociateHourlyRateWithIncentiveCalculated = Number(this.txtHourlyRateAssociateCalculated) + (this.resultAssociateEarnedIncentiveCalculated/(this.txtHoursWorkedPerDayAssociateCalculated*this.txtDaysWorkedPerWeekAssociateCalculated*4.4));
        /*Total Associate Earnings*/
        this.resultAssociateTotalEarningsCurrent = this.resultAssociateWagesCurrent + this.resultAssociateEarnedIncentiveCurrent;
        this.resultAssociateTotalEarningsCalculated = this.resultAssociateWagesCalculated + this.resultAssociateEarnedIncentiveCalculated;
        /*Employee Benefits*/
        this.resultEmployeeBenefitsCurrent = (this.resultLeadWagesCurrent + this.resultAssociateWagesCurrent) * .125;
        this.resultEmployeeBenefitsCalculated = (this.resultLeadWagesCalculated + this.resultAssociateWagesCalculated) * .125;
        /*Center Gross Profits*/
        this.resultCenterGrossProfitCurrent = this.resultGrossProfitCurrent - this.resultTotalHygienistEarningsCurrent - this.resultEmployeeBenefitsCurrent;
        this.resultCenterGrossProfitCalculated = this.resultGrossProfitCalculated - this.resultTotalHygienistEarningsCalculated - this.resultEmployeeBenefitsCalculated;
        /*MCD Profit Sharing*/
        this.resultMCDProfitSharingCurrent = (this.resultGrossProfitCurrent-this.resultTotalHygienistEarningsCurrent) * this.txtMCDProfitSharePercentCurrent/100;
        this.resultMCDProfitSharingCalculated = (this.resultGrossProfitCalculated-this.resultTotalHygienistEarningsCalculated) * this.txtMCDProfitSharePercentCalculated/100;
        /*PC Net Profit*/
        this.resultPCNetProfitsCurrent = (this.resultCenterGrossProfitCurrent*.55)-this.resultMCDProfitSharingCurrent;
        this.resultPCNetProfitsCalculated = (this.resultCenterGrossProfitCalculated*.55)-this.resultMCDProfitSharingCalculated;





        /*Format numbers for display*/
        this.resultHygieneRevenueCurrentFormatted = this.roundAndFormat(this.resultHygieneRevenueCurrent);
        this.resultHygieneRevenueCalculatedFormatted = this.roundAndFormat(this.resultHygieneRevenueCalculated);
        this.resultHygieneSuppliesCurrentFormatted = this.roundAndFormat(this.resultHygieneSuppliesCurrent);
        this.resultHygieneSuppliesCalculatedFormatted = this.roundAndFormat(this.resultHygieneSuppliesCalculated);
        this.resultAssociateWagesCurrentFormatted = this.roundAndFormat(this.resultAssociateWagesCurrent);
        this.resultAssociateWagesCalculatedFormatted = this.roundAndFormat(this.resultAssociateWagesCalculated);
        this.resultGrossProfitCurrentFormatted = this.roundAndFormat(this.resultGrossProfitCurrent);
        this.resultGrossProfitCalculatedFormatted = this.roundAndFormat(this.resultGrossProfitCalculated);
        this.resultProfitSharingCurrentFormatted = this.resultProfitSharingCurrent;
        this.resultProfitSharingCalculatedFormatted = this.resultProfitSharingCalculated;
        this.resultEligibleProfitSharingCurrentFormatted = this.roundAndFormat(this.resultEligibleProfitSharingCurrent);
        this.resultEligibleProfitSharingCalculatedFormatted = this.roundAndFormat(this.resultEligibleProfitSharingCalculated);
        this.resultLeadWagesCurrentFormatted = this.roundAndFormat(this.resultLeadWagesCurrent);
        this.resultLeadWagesCalculatedFormatted = this.roundAndFormat(this.resultLeadWagesCalculated);
        this.resultHygienistWageAmountCurrentFormatted = this.roundAndFormat(this.resultHygienistWageAmountCurrent);
        this.resultHygienistWageAmountCalculatedFormatted = this.roundAndFormat(this.resultHygienistWageAmountCalculated);
        this.resultLeadEarnedIncentiveCurrentFormatted = this.roundAndFormat(this.resultLeadEarnedIncentiveCurrent);
        this.resultLeadEarnedIncentiveCalculatedFormatted = this.roundAndFormat(this.resultLeadEarnedIncentiveCalculated);
        this.resultLeadHourlyRateWithIncentiveCurrentFormatted = this.roundAndFormat(this.resultLeadHourlyRateWithIncentiveCurrent);
        this.resultLeadHourlyRateWithIncentiveCalculatedFormatted = this.roundAndFormat(this.resultLeadHourlyRateWithIncentiveCalculated);
        this.resultHourlyRateWithIncentiveCurrentFormatted = this.currencyFormat(this.resultHourlyRateWithIncentiveCurrent).substring(1);
        this.resultHourlyRateWithIncentiveCalculatedFormatted = this.currencyFormat(this.resultHourlyRateWithIncentiveCalculated).substring(1);
        this.resultTotalHygienistEarningsCurrentFormatted = this.roundAndFormat(this.resultTotalHygienistEarningsCurrent);
        this.resultTotalHygienistEarningsCalculatedFormatted = this.roundAndFormat(this.resultTotalHygienistEarningsCalculated);

        this.resultAssociateRevenueCurrentFormatted = this.roundAndFormat(this.resultAssociateRevenueCurrent);
        this.resultAssociateRevenueCalculatedFormatted = this.roundAndFormat(this.resultAssociateRevenueCalculated);
        this.resultAssociateProfitSharingCurrentFormatted = this.roundAndFormat(this.resultAssociateProfitSharingCurrent);
        this.resultAssociateProfitSharingCalculatedFormatted = this.roundAndFormat(this.resultAssociateProfitSharingCalculated);
        this.resultAssociateEarnedIncentiveCurrentFormatted = this.roundAndFormat(this.resultAssociateEarnedIncentiveCurrent);
        this.resultAssociateEarnedIncentiveCalculatedFormatted = this.roundAndFormat(this.resultAssociateEarnedIncentiveCalculated);
        /*this.resultLeadHourlyRateWithIncentiveCurrentFormatted = this.roundAndFormat(this.resultLeadHourlyRateWithIncentiveCurrent);
        this.resultLeadHourlyRateWithIncentiveCalculatedFormatted = this.roundAndFormat(this.resultLeadHourlyRateWithIncentiveCalculated);*/
        this.resultAssociateEffectiveHourlyRateCurrentFormatted = this.roundAndFormat(this.resultAssociateEffectiveHourlyRateCurrent);
        this.resultAssociateEffectiveHourlyRateCalculatedFormatted = this.roundAndFormat(this.resultAssociateEffectiveHourlyRateCalculated);
        this.resultAssociateTotalEarningsCurrentFormatted = this.roundAndFormat(this.resultAssociateTotalEarningsCurrent);
        this.resultAssociateTotalEarningsCalculatedFormatted = this.roundAndFormat(this.resultAssociateTotalEarningsCalculated);
        this.resultEmployeeBenefitsCurrentFormatted = this.roundAndFormat(this.resultEmployeeBenefitsCurrent);
        this.resultEmployeeBenefitsCalculatedFormatted = this.roundAndFormat(this.resultEmployeeBenefitsCalculated);
        this.resultCenterGrossProfitCurrentFormatted = this.roundAndFormat(this.resultCenterGrossProfitCurrent);
        this.resultCenterGrossProfitCalculatedFormatted = this.roundAndFormat(this.resultCenterGrossProfitCalculated);
        this.resultMCDProfitSharingCurrentFormatted = this.roundAndFormat(this.resultMCDProfitSharingCurrent);
        this.resultMCDProfitSharingCalculatedFormatted = this.roundAndFormat(this.resultMCDProfitSharingCalculated);
        this.resultPCNetProfitsCurrentFormatted = this.roundAndFormat(this.resultPCNetProfitsCurrent);
        this.resultPCNetProfitsCalculatedFormatted = this.roundAndFormat(this.resultPCNetProfitsCalculated);
      },
      updateState(state) {
        var selectedState = this.states.filter(function(ele){
          return (ele.name == state)
        });
        if(selectedState.length){this.planType = selectedState[0].planType}
        if(this.planType == "Standard") {
            this.compensationProgramSummaryURL = "https://cdn.phenompeople.com/CareerConnectResources/ASDEUS/documents/HygieneCompensation_Flyer_Sept23-1705078789495.pdf";
        }
        else if(this.planType == "Accelerated") {
            this.compensationProgramSummaryURL = "https://cdn.phenompeople.com/CareerConnectResources/ASDEUS/documents/HygieneCompensation_HighStates-1705078788890.pdf";
        }
        this.updateFields();
      },
      roundAndFormat(number) {
        var result = Math.round(number);
        result = result.toLocaleString();
        return result;
      },
      currencyFormat(number){
        var currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
        return currency;
      },
      getProfitSharing(loyaltyScore) {
          var profitShare = 0;
          if (loyaltyScore < 34.9) {
            if(this.planType == "Standard"){profitShare = 19.5;}
            else if(this.planType == "Accelerated") {profitShare = 23}
          }
          else if(loyaltyScore < 54.9) {
            if(this.planType == "Standard"){profitShare = 20;}
            else if(this.planType == "Accelerated") {profitShare = 23.5}
          }
          else if(loyaltyScore < 74.9) {
            if(this.planType == "Standard"){profitShare = 20.5;}
            else if(this.planType == "Accelerated") {profitShare = 24}
          }
          else if(loyaltyScore < 79.9) {
            if(this.planType == "Standard"){profitShare = 21;}
            else if(this.planType == "Accelerated") {profitShare = 24.5}
          }
          else {
            if(this.planType == "Standard"){profitShare = 21.5;}
            else if(this.planType == "Accelerated") {profitShare = 25}
          }
          return profitShare;
      },
      reset(){
        this.planType = 'Standard';
        this.txtProductionPerDayCurrent = "1,900";
        this.txtProductionPerDayCalculated = "1,900";
        this.txtHourlyRateCurrent = 40;
        this.txtHourlyRateCalculated = 40;
        this.txtHoursWorkedPerDayCurrent = 8;
        this.txtHoursWorkedPerDayCalculated = 8;
        this.txtDaysWorkedPerWeekCurrent = 4;
        this.txtDaysWorkedPerWeekIncremental = 4;
        this.txtPatientLoyaltyScoreCurrent = 55;
        this.txtPatientLoyaltyScoreCalculated = 55;
        this.resultHygieneRevenueCurrent = null;
        this.resultHygieneRevenueCalculated = null;
        this.resultHygieneRevenueIncremental = null;
        this.resultHygieneSuppliesCurrent = null;
        this.resultHygieneSuppliesCalculated = null;
        this.resultHygieneSuppliesIncremental = null;
        this.resultGrossProfitCurrent  = null;
        this.resultGrossProfitCalculated  = null;
        this.resultGrossProfitIncremental  = null;
        this.resultEligibleProfitSharingCurrent = null;
        this.resultEligibleProfitSharingCalculated = null;
        this.resultProfitSharing = 16;
        this.resultEligibleProfitSharing = 16;
        this.resultHygienistWageAmount = null;
        this.resultLeadEarnedIncentive = null;
        this.resultTotalHygienistEarnings = null;
        this.resultHourlyIncentive = null;
        this.resultHourlyRateWithIncentive = null;
        this.resultTotalHygienistEarnings = null;
        this.updateFields();
      },/*
          showCaptureRef() {
      console.log("this.$refs.capture: " + this.$refs.capture);
      let vc = this;
      return vc.$refs.capture;
    },*/
      getScreenShot(){
        //ar element = document.getElementById("calculator-wrapper");
        /*html2canvas(element, {
          onrendered: function(canvas) {
          var dataURL = canvas.toDataURL();
          //generated dataURL is now placed as src of a img tag
          document.getElementById('screenshot').src = dataURL;
        }
        });
        html2canvas(element, {
          onrendered: function(canvas) {
            var img = canvas.toDataURL()
            window.open(img);
          }
        });*/
      // alert("Descargando reporte visual")
      console.log('rendering screenshot');
      html2canvas(document.body).then(canvas => {
          document.body.appendChild(canvas)
      }).catch((error) => {
        console.log("Error: ", error)
      });





      }
    },

    data: () => ({
      compensationProgramSummaryText: "Dental Hygienist Compensation Program Summary",
      compensationProgramSummaryURL: "https://cdn.phenompeople.com/CareerConnectResources/ASDEUS/documents/HygieneCompensation_Flyer_Sept23-1705078789495.pdf",
      planType: 'Standard',
      txtProductionPerDayCurrent: "1,900",
      txtProductionPerDayCalculated: "1,900",
      txtHourlyRateCurrent: "40.10",
      txtHourlyRateCalculated: "40.10",
      txtHoursWorkedPerDayCurrent: 8,
      txtHoursWorkedPerDayCalculated: 8,
      txtDaysWorkedPerWeekCurrent: 4,
      txtDaysWorkedPerWeekCalculated: 4,
      txtPatientLoyaltyScoreCurrent: 55,
      txtPatientLoyaltyScoreCalculated: 55,
      resultHygieneRevenueCurrent: null,
      resultHygieneRevenueCalculated: null,
      resultHygieneRevenueIncremental: null,
      resultHygieneSuppliesCurrent: null,
      resultHygieneSuppliesCalculated: null,
      resultHygieneSuppliesIncremental: null,
      resultAssociateWagesCurrent: null,
      resultAssociateWagesCalculated: null,
      resultLeadWagesCurrent: null,
      resultLeadWagesCalculated: null,
      resultGrossProfitCurrent: null,
      resultGrossProfitCalculated: null,
      resultGrossProfitIncremental: null,
      resultHygieneSupplies: null,
      resultGrossProfit : null,
      resultProfitSharingCurrent: 16,
      resultProfitSharingCalculated: 16,
      resultEligibleProfitSharing: null,
      resultHygienistWageAmount: null,
      resultHourlyIncentive: null,
      resultLeadEarnedIncentive: null,
      resultTotalHygienistEarnings: null,


      /*Associate Hygienist data */
      txtProductionPerDayAssociateCurrent: 1900.0,
      txtProductionPerDayAssociateCalculated: 1900.0,
      txtHourlyRateAssociateCurrent: "40.10",
      txtHourlyRateAssociateCalculated: "40.10",
      txtHoursWorkedPerDayAssociateCurrent: 8,
      txtHoursWorkedPerDayAssociateCalculated: 8,
      txtDaysWorkedPerWeekAssociateCurrent: 4,
      txtDaysWorkedPerWeekAssociateCalculated: 4,
      txtMCDProfitSharePercentCurrent: 18,
      txtMCDProfitSharePercentCalculated: 18,

      resultAssociateProfitSharingCurrent: null,
      resultAssociateProfitSharingCalculated: null,
      resultAssociateHourlyRateWithIncentiveCurrent: null,
      resultAssociateHourlyRateWithIncentiveCalculated: null,
      resultTotalAssociateEarningsCurrent: null,
      resultTotalAssociateEarningsCalculated: null,

      resultAssociateRevenueCurrent: null,
      resultAssociateRevenueCalculated: null,
      resultAsssociateProfitSharingCurrent: null,
      resultAsssociateProfitSharingCalculated: null,
      resultAssociateEarnedIncentiveCurrent: null,
      resultAssociateEarnedIncentiveCalculated: null,
      resultLeadHourlyRateWithIncentiveCurrent: null,
      resultLeadHourlyRateWithIncentiveCalculated: null,
      resultAssociateEffectiveHourlyRateCurrent: null,
      resultAssociateEffectiveHourlyRateCalculated: null,
      resultAssociateTotalEarningsCurrent: null,
      resultAssociateTotalEarningsCalculated: null,
      resultEligibleProfitSharingCurrent: null,
      resultEligibleProfitSharingCalculated: null,

      /*Monthly POP P&L*/
      resultEmployeeBenefitsCurrent: null,
      resultEmployeeBenefitsCalculated: null,
      resultCenterGrossProfitCurrent: null,
      resultCenterGrossProfitCalculated: null,
      resultMCDProfitSharingCurrent: null,
      resultMCDProfitSharingCalculated: null,
      resultPCNetProfitsCurrent: null,
      resultPCNetProfitsCalculated: null,


      /*Formateted for display*/
      resultHygieneRevenueCurrentFormatted: null,
      resultHygieneRevenueCalculatedFormatted: null,
      resultHygieneRevenueIncrementalFormatted: null,
      resultHygieneSuppliesCurrentFormatted: null,
      resultHygieneSuppliesCalculatedFormatted: null,
      resultHygieneSuppliesIncrementalFormatted: null,
      resultAssociateWagesCurrentFormatted: null,
      resultAssociateWagesCalculatedFormatted: null,
      resultGrossProfitCurrentFormatted: null,
      resultGrossProfitCalculatedFormatted: null,
      resultProfitSharingCurrentFormatted: null,
      resultProfitSharingCalculatedFormatted: null,
      resultEligibleProfitSharingCurrentFormatted: null,
      resultEligibleProfitSharingCalculatedFormatted: null,
      resultLeadWagesCurrentFormatted: null,
      resultLeadWagesCalculatedFormatted: null,
      resultHygienistWageAmountCurrentFormatted: null,
      resultHygienistWageAmountCalculatedFormatted: null,
      resultLeadEarnedIncentiveCurrentFormatted: null,
      resultLeadEarnedIncentiveCalculatedFormatted: null,
      resultLeadHourlyRateWithIncentiveCurrentFormatted: null,
      resultLeadHourlyRateWithIncentiveCalculatedFormatted: null,
      resultHourlyRateWithIncentiveCurrentFormatted: null,
      resultHourlyRateWithIncentiveCalculatedFormatted: null,
      resultTotalHygienistEarningsCurrentFormatted: null,
      resultTotalHygienistEarningscalculatedFormatted: null,
      resultEmployeeBenefitsCurrentFormatted: null,
      resultEmployeeBenefitsCalculatedFormatted: null,
      resultCenterGrossProfitCurrentFormatted: null,
      resultCenterGrossProfitCalculatedFormatted: null,
      resultMCDProfitSharingCurrentFormatted: null,
      resultMCDProfitSharingCalculatedFormatted: null,
      resultPCNetProfitsCurrentFormatted: null,
      resultPCNetProfitsCalculatedFormatted: null,

      tipProductionPerDay: "<p><strong>Production Per Day</strong></p>Average net production charged out per day worked by Hygienists. This averages when there are multiple Hygienists working, it does not add them together. This is impacted by adjustments for patients previously seen by current providers in the same location.",
      tipHourlyRate: "<p><strong>Hourly Rate</strong></p>The hourly rate the Hygienist is paid.",
      tipHoursWorkedPerDay: "<p><strong>Hours Worked Per Day</strong></p>Total hours worked by the Hygienist per day.",
      tipDaysWorkedPerWeek: "<p><strong>Days Worked Per Week</strong></p>Total days worked by the Hygienist per week.",
      tipPatientLoyaltyScore: "<p><strong>New Patient Net Promoter Score (NPS) </strong></p>%Promoters -%Detractors = Net Promoter Score",
      tipMCDProfitSharePercent: "<p><strong>MCD Profit Share Percent</strong></p>The profit sharing % that the MCD in the office is eligible to receive.",
      tipHygieneRevenue: "<p><strong>Hygiene Revenue</strong></p>Net revenue charged out for work performed by Hygienists. This can be impacted by adjustments for patients seen previously.  Assume 4.4 weeks worked per month.",
      tipHygieneSupplies: "<p><strong>Hygiene Supplies</strong></p>Hygiene supplies purchased in the month.",
      tipAssociateWages: "<p>Associate Wages</p>Associate hygienist wages for the month. Includes all paid hours.",
      tipGrossProfit : "<p><strong>Gross Profit</strong></p>Hygiene revenue minus Hygiene supplies.",
      tipProfitSharing: "<p><strong>Profit Sharing %</strong></p>Eligible Hygienist profit sharing % based on  Patient Net Promoter Score (NPS) .",
      tipEligibleProfitSharing: "<p><strong>Eligible Hygienist Profit Sharing (Total Hygienist Earnings)</strong></p>Gross Profit multiplied by the Profit Sharing %",
      tipLeadWages: "<p><strong>Hygieniest Monthly Wages Paid</strong> Hygienist wages for the month. Includes all paid hours.  Assume 4.4 weeks worked per month.",
      tipHygienistWageAmount: "<p><strong>Hygienist Monthly Wages Paid</strong></p>Hygienist wages for the month. Includes all paid hours.  Assume 4.4 weeks worked per month.",
      tipHygienistEarnedIncentive: "<p><strong>Hygienist Earned Incentive</strong></p>Eligible Profit Sharing minus Hygienist wages.",
      tipLeadHourlyRateWithIncentive:"<p><strong>Effective Hourly Rate</strong></p>Lead Hygienist hourly rate with base pay plus earned incentive",
      tipTotalHygienistEarnings:  "<p><strong>Total Hygienist Earnings</strong></p>Hygienist wages plus earned incentive.",
      tipHourlyRateWithIncentive: "<p><strong> Lead Effective Hourly Rate</strong></p>Lead Hygienist hourly rate with base pay plus earned incentive.",
      tipTotalHygienestEarnings: "<p><strong> Total Hygienist Earnings</strong></p>Hygienist wages plus earned incentive.",
      tipAssociateRevenue: "<p><strong>Associate Revenue</strong></p> Net revenue charged out for work performed by the Associate Hygienist. This can be impacted by adjustments for patients seen previously.",
      tipAssocaiteProfitSharing: "<p><strong>Associate Profit Sharing %</strong></p> Eligible associate profit sharing.",
      tipAssociateEarnedIncentive: "<p><strong>Associate Earned Incentive</strong></p> Associate revenue multiplied by 3% profit sharing.",
      tipAssociateHourlyRateWithIncentive: "<p><strong>Associate Effective Hourly Rate</strong></p>Associate Hygienist hourly rate with base pay plus earned incentive",
      tipTotalAssociateEarings: "<p><strong>Total Associate Earnings</strong></p> Associate wages plus earned incentive.",
      tipEmployeeBenefits: "<p><strong>Employee Benefits</strong></p>Employee Benefits” needs to be changed to: “A percent of monthly total earnings meant to cover taxes, health insurance, 401k, etc.",
      tipCenterGrossProfit: "<p><strong>Center Gross Profit</strong></p>Hygiene revenue minus related hygiene costs.",
      tipMCDProfitSharing: "<p><strong>MCD Profit Sharing</strong></p>Profit sharing paid to the MCD based on their eligible portion of gross profit.",
      tipPCNetProfit: "<p><strong>PC Net Profit</strong></p>Center Gross Profit multiplied 55% minus doctor costs (at 100%).",

      states: [
        {name: 'Alabama', planType: 'Standard'},
        {name: 'Alaska', planType: 'Standard'},
        {name: 'Arizona', planType: 'Accelerated'},
        {name: 'Arkansas', planType: 'Standard'},
        {name: 'California', planType: 'Accelerated'},
        {name: 'Colorado', planType: 'Standard'},
        {name: 'Connecticut', planType: 'Accelerated'},
        {name: 'Delaware', planType: 'Standard'},
        {name: 'Florida', planType: 'Standard'},
        {name: 'Georgia', planType: 'Standard'},
        {name: 'Hawaii', planType: 'Standard'},
        {name: 'Idaho', planType: 'Standard'},
        {name: 'Illinois', planType: 'Standard'},
        {name: 'Indiana', planType: 'Standard'},
        {name: 'Iowa', planType: 'Standard'},
        {name: 'Kansas', planType: 'Standard'},
        {name: 'Kentucky', planType: 'Standard'},
        {name: 'Lousiana', planType: 'Standard'},
        {name: 'Maine', planType: 'Standard'},
        {name: 'Maryland', planType: 'Standard'},
        {name: 'Massachusetts', planType: 'Accelerated'},
        {name: 'Michigan', planType: 'Standard'},
        {name: 'Minnesota', planType: 'Standard'},
        {name: 'Mississippi', planType: 'Standard'},
        {name: 'Missouri', planType: 'Standard'},
        {name: 'Montana', planType: 'Standard'},
        {name: 'Nebraska', planType: 'Standard'},
        {name: 'Nevada', planType: 'Standard'},
        {name: 'New Hampshire', planType: 'Accelerated'},
        {name: 'New Jersey', planType: 'Standard'},
        {name: 'New Mexico', planType: 'Accelerated'},
        {name: 'New York', planType: 'Standard'},
        {name: 'North Carolina', planType: 'Standard'},
        {name: 'North Dakota', planType: 'Standard'},
        {name: 'Ohio', planType: 'Standard'},
        {name: 'Oklahoma', planType: 'Accelerated'},
        {name: 'Oregon', planType: 'Accelerated'},
        {name: 'Pennsylvania', planType: 'Standard'},
        {name: 'Rhode Island', planType: 'Accelerated'},
        {name: 'South Carolina', planType: 'Standard'},
        {name: 'South Dakota', planType: 'Standard'},
        {name: 'Tennessee', planType: 'Standard'},
        {name: 'Texas', planType: 'Standard'},
        {name: 'Utah', planType: 'Standard'},
        {name: 'Vermont', planType: 'Standard'},
        {name: 'Virginia', planType: 'Standard'},
        {name: 'Washington', planType: 'Accelerated'},
        {name: 'West Virginia', planType: 'Standard'},
        {name: 'Wisconsin', planType: 'Standard'},
        {name: 'Wyoming', planType: 'Standard'},
      ],
    }),
    watch: {
      txtProductionPerDayCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtProductionPerDayCurrent = result);
      },
      txtProductionPerDayCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtProductionPerDayCalculated = result);
      },
    },
    created(){
      this.updateFields();
    },
  }
</script>
